import React from 'react'
import Fruits from '../Images/kpn-fruits.png';
import Vegetables from '../Images/kpn-vegetables.png';
import Grocery from '../Images/kpn-grocery.png';
import Mango from '../Images/kpn-3.png';






export const Items = () => {
  return (
    <div>
    <div className='items'>
        <div className="img-container">
            <div className="box">
                <img src={Vegetables} alt=''/>
                <h4>Vegetables</h4>
            </div>
        </div>
        <div className="img-container">
            <div className="box">
                <img src={Grocery} alt=''/>
                <h4>Grocery</h4>
            </div>
        </div>
        <div className="img-container">
            <div className="box">
                <img src={Fruits} alt=''/>
                <h4>Fruits</h4>
            </div>
        </div>
    </div>

    <div  className='mango'>
    <img src={Mango} alt=''/>
    </div>
    </div>
  )
}




